export default "__VITE_ASSET__wNDnzdj0__"